module.exports = __webpack_public_path__ + "static/media/waveEmoji.43c7a73f.png";